import React, { useEffect, useState } from "react";
import useTranslation from "next-translate/useTranslation";
import { Col, Row, Pagination } from "antd";
import PropTypes from "prop-types";

import { getNewsApi } from "@libs/apis/news";

import NewsItem from "./NewsItem";

const News = ({ dataNews }) => {
  const { t } = useTranslation("newsPage");

  const [listNewss, setListNews] = useState([]);

  useEffect(() => {
    setListNews(dataNews?.docs || []);
  }, [dataNews]);

  const handleChangePage = async (page) => {
    const res = await getNewsApi({
      page: page,
      limit: 10,
      populate: "image.file, newsCategory",
    });
    if (res?.status === 200) {
      setListNews(res?.data?.data?.docs || []);
    }
  };

  return (
    <section className="news-page">
      <div className="news-page__header">
        <div className="news-page__header__content">
          <h1>{t("title")}</h1>
        </div>
      </div>
      <div className="news-page__container">
        <div className="news-page__container__content">
          <Row gutter={[24, 49]}>
            {listNewss?.map((i) => (
              <React.Fragment key={i?.id || ""}>
                <Col xl={6} lg={8} md={12} xs={24}>
                  <NewsItem
                    title={i?.title || ""}
                    type={i?.newsCategory?.[0]?.name || ""}
                    dateTime={i?.startDate ? i?.startDate : i?.createdAt || ""}
                    src={i?.image || []}
                    slug={i?.titleSlug || ""}
                  />
                </Col>
              </React.Fragment>
            ))}
          </Row>
        </div>

        <div className="news-page__container__paginate">
          <Pagination
            className="paginate"
            pageSize={dataNews?.limit || 1}
            total={dataNews?.totalPages * dataNews?.limit || 1}
            onChange={handleChangePage}
          />
        </div>
      </div>
    </section>
  );
};

News.propTypes = {
  dataNews: PropTypes.object,
};

export default News;
